module.exports = __webpack_public_path__ + "static/media/2 (1).79d4b6e8.jpg";